<div>
  <div id="ctnLogo">
    <h1>Entities Convertor</h1>
    <p><img src="/assets/logo.png" alt="logo"></p>
  </div>
</div>
